module.exports = __webpack_public_path__ + "static/img/1.f81056d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/zh/1.png
// module id = 2M8u
// module chunks = 0